import { useQuery } from '@tanstack/react-query';
import { fetchData } from 'utils';
import formatHTML from 'utils/formatHTML';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';

export default function useAgreementQuery({
  amount,
  term,
  fileType,
  enabled = true,
}: {
  amount?: number;
  enabled?: boolean;
  term?: number;
  fileType: 'PDF' | 'HTML';
}) {
  const { error } = useSmartlook();
  const { showError } = useError();
  return useQuery<Blob | string | null>({
    queryKey: [
      'agreement',
      {
        amount,
        term,
        fileType,
      },
    ],
    queryFn: async () => {
      if (!amount || !term) {
        return null;
      }

      const strObj = {
        amount: `${amount}`,
        term: `${term}`,
        fileType,
      };

      try {
        const urlParams = new URLSearchParams(strObj).toString();
        const res = await fetchData(
          `/client/agreements/preliminary?${urlParams}`,
          {
            headers: {
              'Content-Type':
                fileType === 'PDF' ? 'application/pdf' : 'text/html',
            },
          },
        );
        return fileType === 'PDF' ? (res as Blob) : formatHTML(res);
      } catch (e) {
        error(
          '[useAgreementQuery][GET /client/agreements/preliminary?{urlParams}]',
          e,
        );
        showError();
        throw e;
      }
    },
    staleTime: Infinity,
    enabled,
  });
}
